/**
 * Sarni — site-wide launcher.
 *
 * Opens the standalone app (ai.sarnion.com) in a NEW TAB.
 * We deliberately do NOT embed it in an iframe:
 *   - it's a full app with its own nav/footer → "a site within a site" (bad on mobile)
 *   - Google sign-in refuses to load inside an iframe (returns 403)
 *   - iframes are slower and cross-origin auth is fragile
 *
 * Triggers — any of these open the app:
 *   [data-sarni-open]              → opens /studio
 *   [data-sarni-context="q=..."]   → appends a query string (context for the app)
 *   [data-sarni-path="/shop"]      → overrides the app path (default /studio)
 *   <a href="#sarni">              → opens too (use anywhere, even theme menus)
 */
(function () {
  'use strict';

  var cfg = window.SarniConfig || {};
  var BASE = (cfg.baseUrl || 'https://ai.sarnion.com').replace(/\/$/, '');
  var DEFAULT_PATH = cfg.defaultPath || '/studio';

  function buildUrl(path, query) {
    var p = path || DEFAULT_PATH;
    if (p.charAt(0) !== '/') p = '/' + p;
    var url = BASE + p;
    if (query) url += (url.indexOf('?') > -1 ? '&' : '?') + query;
    return url;
  }

  // Open in a new tab reliably: a synthetic <a> click keeps the user gesture,
  // so mobile popup blockers allow it; rel=noopener for safety.
  function open(path, query) {
    var a = document.createElement('a');
    a.href = buildUrl(path, query);
    a.target = '_blank';
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // Delegated trigger handling — works for current and future elements.
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sarni-open], a[href="#sarni"], a[href$="#sarni"]');
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-sarni-path'), t.getAttribute('data-sarni-context'));
  });

  // Public API, e.g. window.Sarni.open('/studio', 'ref=hero')
  window.Sarni = { open: open };
})();
